import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTranslation } from 'react-i18next'

export const ConfirmationDialog = ({ open, onClose }) => {
  const { t } = useTranslation()
  const fullScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      maxWidth="sm"
      onClose={onClose}
      open={open}
    >
      <DialogTitle>{t('Thanks for signing up')}</DialogTitle>
      <DialogContent>
        {t('We will keep you updated about the project.')}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('Close')}</Button>
      </DialogActions>
    </Dialog>
  )
}
